import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrPricelabsSyncState.ts
var t = () => e("pricelabsSyncState");
//#endregion
export { t as useTrPricelabsSyncState };
